import * as React from 'react'
import LDMarker from './LDMarker'

interface AsyncCallsMarkersProps {
  scopes: string[]
}

class AsyncCallsMarkers extends React.Component<AsyncCallsMarkersProps> {
  render() {
    if (!this.props.scopes) {
      return null
    }
    return this.props.scopes.map(scope => (
      <div key={scope}>
        <LDMarker scope={scope} />
      </div>
    ))
  }
}

export default AsyncCallsMarkers
